import React, { FC } from 'react';

import FootnoteItem, { FootnoteItemProps } from './footnote-item/FootnoteItem';

export interface FootnoteProps {
  items: FootnoteItemProps[];
  showIdentifier?: boolean;
}

const Footnote: FC<FootnoteProps> = (props: FootnoteProps) => {
  const { items, showIdentifier } = props;

  const className = {
    container: 'relative py-20px text-grey60 text-legal w-full',
    item: 'w-full',
  };
  return (
    <div className={className.container}>
      <ul>
        {items.map((item, id) => (
          <FootnoteItem
            key={`footnote-${item.type}-${id}`}
            content={item.content}
            id={id + 1}
            type={item.type}
            showIdentifier={showIdentifier}
          />
        ))}
      </ul>
    </div>
  );
};

export default Footnote;
